import Main from "./components/Main/Main";

export default Main;
